import { render, staticRenderFns } from "./MatchMakingModalCard.vue?vue&type=template&id=0482990b&scoped=true&"
import script from "./MatchMakingModalCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./MatchMakingModalCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482990b",
  null
  
)

export default component.exports